import type {SVGProps} from 'react'
const CircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" {...props}>
    <circle cx={6} cy={6} r={5} stroke="#fff" strokeWidth={2} />
  </svg>
)
export {CircleIcon}
